import { Lightbulb } from "lucide-react";
import { SG7TacticalPanel } from "./sg7";
import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";

interface HighlightsListProps {
  highlights: string[];
  className?: string;
}

export function HighlightsList({ highlights, className }: HighlightsListProps) {
  const { t } = useTranslation('analysis');

  if (!highlights || highlights.length === 0) return null;

  return (
    <SG7TacticalPanel className={className}>
      <div className="p-4">
        <h3 className="text-sm font-bold flex items-center gap-2 text-[hsl(var(--sg7-text))] mb-3">
          <Lightbulb className="h-4 w-4 text-[hsl(var(--sg7-gold))]" />
          {t('cards.highlights')}
        </h3>
        <ul className="space-y-2">
          {highlights.map((highlight, index) => (
            <li 
              key={index}
              className="flex items-start gap-3 text-sm"
            >
              <span className={cn(
                "flex-shrink-0 w-5 h-5 rounded-full",
                "border border-[hsl(var(--sg7-gold))]",
                "text-[hsl(var(--sg7-gold))]",
                "flex items-center justify-center text-xs font-bold"
              )}>
                {index + 1}
              </span>
              <span className="text-[hsl(var(--sg7-text))]">{highlight}</span>
            </li>
          ))}
        </ul>
      </div>
    </SG7TacticalPanel>
  );
}
